/* eslint-disable no-console, import/no-mutable-exports  */
import React, { useEffect, useRef, useState } from 'react';
import { Container, Text } from './Tooltip.style';

export let openTooltip = (_: string, __: any) => {
  console.warn('Tooltip not initialised');
};

export let closeTooltip = () => {
  console.warn('Tooltip not initialised');
};

const TOOLTIP_WIDTH = 160;

const getLeft = (anchor: string, left: number, width: number) => {
  if (anchor === 'left') {
    return left - 5;
  }

  if (anchor === 'right') {
    return left + width - TOOLTIP_WIDTH + 15;
  }

  return left - TOOLTIP_WIDTH / 2 + width / 2;
};

const Tooltip = () => {
  const [text, setText] = useState('');
  const [top, setTop] = useState(0);
  const [left, setLeft] = useState(0);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [anchor, setAnchor] = useState<string>('middle');

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (text) {
      const timer = setTimeout(() => {
        setText('');
      }, 5000);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, [text]);

  useEffect(() => {
    openTooltip = (mText, event) => {
      setText('');

      setTimeout(() => {
        setText(mText);
        const rect = event.target.getBoundingClientRect();
        setWidth(rect.width);
        setTop(rect.top + window.scrollY);
        setLeft(rect.left);

        if (rect.left < 60) setAnchor('left');
        else if (window.innerWidth - rect.right < 100) setAnchor('right');
        else setAnchor('middle');
      }, 100);
    };

    closeTooltip = () => {
      setText('');
    };

    window.addEventListener('resize', closeTooltip);

    if (containerRef.current) {
      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          setHeight(entry.target.getBoundingClientRect().height);
        });
      });

      observer.observe(containerRef.current);

      return () => {
        observer.disconnect();
      };
    }

    return () => {
      window.removeEventListener('resize', closeTooltip);
    };
  }, []);

  return (
    <Container
      ref={containerRef}
      anchor={anchor}
      style={{
        visibility: text ? 'visible' : 'hidden',
        top: text ? top - height - 15 : 0,
        left: text ? getLeft(anchor, left, width) : 0,
        transform: text ? 'translateY(0px)' : 'translateY(-20px)',
        opacity: text ? 1 : 0,
      }}
      data-testid="tooltip"
      data-anchor={anchor}
    >
      <Text>{text}</Text>
    </Container>
  );
};

export default Tooltip;
